module.exports = __webpack_public_path__ + "static/scientist2-dfcbe9d700ea0a79f97616d392dcb28f.png";